import React from "react";
import StudentAvatar from './assets/students.png';
import TeacherAndParentAvatar from './assets/teacher-and-parents.png';
import { useAuthSigninState } from "./state";

const LOGIN_TILES = [
    {
        index: 0,
        label: 'Student',
        avatar: StudentAvatar,
        hash: '#student',
        clickedOn: "Class",
        clickedOnDesc: "Classroom",
        dataTestId: 'login-tile-student'
    },
    {
        index: 1,
        label: 'Teacher/Parent',
        avatar: TeacherAndParentAvatar,
        hash: '#parent',
        clickedOn: "Teacher and Parent",
        dataTestId: 'login-tile-teacher-and-parent'
    }
]

const Tile = ({tile = {}}: any) => {
    const { sendEvent } = useAuthSigninState();

    const tilesOnClickHandler = (tile: any) => {
        window.location.href = tile.hash
        trackPageViewOnGa('login-popup')
        trackAnalyticsEvent(`Clicked ${tile.clickedOn} icon`, {"Source": 'Signin Popup', "Intent For": 'signin', "Clicked On": `${tile.clickedOnDesc || tile.clickedOn}`, "Platform": 'web'});
        sendEvent(`Login as ${tile.label}`)
    }

    return (
        <div className="login-tile" onClick={() => tilesOnClickHandler(tile)} data-test-id={tile?.dataTestId}>
            <img src={tile.avatar} alt={tile.avatar}/>
            <h4>{tile.label}</h4>
        </div>
    )
}

export const LoginViewSelector = () => {
    return (
        <div className="login-view-selector">
            <h4>Log In as</h4>
            <div className="login-tiles">
                {LOGIN_TILES.map((tile) => <Tile tile={tile} key={tile.index}/>)}
            </div>
        </div>
    )
}